const commonColumns = [
  { id: 2, key: 'jan', title: 'JAN', isSortable: true },
  { id: 3, key: 'feb', title: 'FEB', isSortable: true },
  { id: 4, key: 'mar', title: 'MAR', isSortable: true },
  { id: 5, key: 'apr', title: 'APR', isSortable: true },
  { id: 6, key: 'may', title: 'MAY', isSortable: true },
  { id: 7, key: 'jun', title: 'JUN', isSortable: true },
  { id: 8, key: 'jul', title: 'JUL', isSortable: true },
  { id: 9, key: 'aug', title: 'AUG', isSortable: true },
  { id: 10, key: 'sep', title: 'SEP', isSortable: true },
  { id: 11, key: 'oct', title: 'OCT', isSortable: true },
  { id: 12, key: 'nov', title: 'NOV', isSortable: true },
  { id: 13, key: 'dec', title: 'DEC', isSortable: true },
  { id: 14, key: 'year', title: 'YEAR', isSortable: true }
];

export default commonColumns;
